<template>
  <b-card class="mb-3">
    <div class="d-flex justify-content-between mb-3" v-if="title">
      <h2 class="mb-0">Recent Users</h2>

      <b-btn variant="secondary" size="sm" to="/admin/users">
        View More
      </b-btn>
    </div>
    <div class="d-flex justify-content-end mx-2 mb-3">
      <b-btn variant="secondary" size="sm" @click="exportUsers()">
        Export
      </b-btn>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th class="text-center">Admin</th>
          <th>Experience</th>
          <th>Areas of Expertise</th>
          <th>Current Project</th>
          <th width="180px;">Role</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="results.length === 0">
          <td class="text-center" colspan="7">
            <em>No users found!</em>
          </td>
        </tr>

        <tr v-for="user in results" :key="user.uuid">
          <td>
            <img
              class="rounded-circle img-profile mr-2"
              :src="user.avatar" :alt="`${user.first_name} ${user.last_name}`">
            {{ user.first_name }} {{ user.last_name }}
          </td>
          <td class="text-center">
            <span class="text-danger" v-if="user.roles === 'admin'">&#x2714;</span>
          </td>
          <td>
            {{
              experienceOptions
                .filter(el => el.value === user.experience)
                .map(el => el ? el.text : '')[0]
            }}
          </td>
          <td>{{ expertiseFormat(user.expertise) }}</td>
          <td>{{ user.company_name }}</td>
          <td>{{ user.company_role }}</td>
          <td style="width: 160px;">
            <b-btn variant="primary" :to="`/user/${user.uuid}`" size="sm" block>
              View Profile
            </b-btn>

            <b-btn variant="secondary" :to="`/admin/users/${user.uuid}`" size="sm" block>
              Edit User
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center" v-if="pagination">
      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page - 1)" :disabled="loading || page === 1"
      >
        Prev Page
      </b-btn>

      <span class="text-muted" v-if="!loading">
        Page {{ page }} of {{ totalPages }}
      </span>

      <span class="text-muted" v-if="loading">
        Loading
      </span>

      <b-btn
        variant="secondary" size="sm"
        @click="setPage(page + 1)" :disabled="loading || page === totalPages"
      >
        Next Page
      </b-btn>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'UsersTable',
  props: {
    count: Number,
    pagination: Boolean,
    title: Boolean
  },
  data () {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      results: [],
      experienceOptions: [
        { text: '< 1 year', value: 'lt_1' },
        { text: '1-5 years', value: '1_5' },
        { text: '5-10 years', value: '5_10' },
        { text: '10-20 years', value: '10_20' },
        { text: '20+ years', value: '20p' }
      ],
      expertiseOptions: [
        { text: 'Finance', value: 'finance' },
        { text: 'Legal', value: 'legal' },
        { text: 'HR', value: 'hr' },
        { text: 'Strategy', value: 'strategy' },
        { text: 'Ops', value: 'ops' },
        { text: 'Tech', value: 'tech' },
        { text: 'Mktg/Sales', value: 'sales' },
        { text: 'Buy/Sell', value: 'buySell' },
        { text: 'Franch', value: 'franchising' },
        { text: 'Intl', value: 'international' },
        { text: 'Govt', value: 'government' },
      ]
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true

      this.$http.get('/admin/users?page=' + this.page + '&page_count=' + this.count)
        .then(res => {
          this.results = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },
    expertiseFormat (expertises) {
      return expertises
        .map(e => e.title.split(' ')[0])
        .join(', ')
    },
    setPage (page) {
      this.page = page
      this.load()
      window.scrollTo(0,0)
    },
    exportUsers() {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$http.post(`/admin/users/export`, { responseType: 'blob' })
        .then(res => {
            var fileUrl = window.URL.createObjectURL(new Blob([res.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileUrl
            fileLink.setAttribute('download', 'users.csv')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.img-profile { width: 24px; height: 24px; }
</style>
